import { apiClient } from 'services/api-client';
import {
  HealthRiskData,
  HealthRisksPayload,
  HealthRisksResponse,
} from './type';
import { getLocale, getProfileId } from 'lib/store';
import useRiskCheckerStore from 'store/risk-checker';

export async function getRiskTrend(): Promise<HealthRiskData> {
  return await apiClient.get('/risk-trend', {
    params: {
      os: 'web',
      locale: getLocale(),
      profile_id: getProfileId(),
    },
  });
}

export async function getHealthRisks({
  risk_type,
}: HealthRisksPayload): Promise<HealthRisksResponse> {
  return await apiClient.get('/risk-engine-v2', {
    params: {
      os: 'web',
      locale: getLocale(),
      profile_id: getProfileId(),
      engine_name: risk_type,
    },
  });
}

export async function executeRiskEngine({
  risk_type,
}: HealthRisksPayload): Promise<HealthRisksResponse> {
  return await apiClient.get('/execute-risk-engine', {
    params: {
      // os: 'web',
      locale: getLocale(),
      profile_id: getProfileId(),
      engine_name: risk_type,
    },
  });
}

export async function postHealthRisksQuestions({
  data,
  scanFlag,
}: {
  data: any;
  scanFlag?: boolean;
}): Promise<HealthRisksResponse> {
  const engineName = useRiskCheckerStore.getState().engineName;
  console.log('🚀 ~ postHealthRisksQuestions ~ engineName:', engineName);

  return await apiClient.post(
    '/risk-engine-v2',
    { data },
    {
      params: {
        os: 'web',
        locale: getLocale(),
        profile_id: getProfileId(),
        ...(scanFlag && { scan_flag: scanFlag }),
        ...(engineName && { engine_name: engineName }),
      },
    }
  );
}
